import { EMPTY_OBJECT } from 'commons-ui';
import _noop from 'lodash/noop';
import useVersionList from '../useVersionList';

type Action = {
	id: string;
	isEnabled: () => boolean;
	name: string;
};

type ActionHandlerParams = {
	history: any;
	rowData: any;
};
export const makeActionHandler = (action: Action, params: ActionHandlerParams) => {
	const { rowData = EMPTY_OBJECT } = params;
	const { revertExperimentToVersion } = useVersionList();
	switch (action.id) {
		case 'revertExperimentToVersion':
			return () => {
				const { _id, abTestId } = rowData;
				revertExperimentToVersion(abTestId, _id);
			};
		default:
			return _noop;
	}
};

export default {
	makeActionHandler
};
